import React, { useState, useEffect, useContext } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import { UserContext } from '../common/UserContext';
import { ToastContainer, toast } from 'react-toastify';
import config from "../../envconfig";

const ShipmentApproval = () => {
  const [shipmentDetails, setShipmentDetails] = useState(null);
  const { shipmentCode } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [actionType, setActionType] = useState('');
  const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useContext(UserContext);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const navigate = useNavigate();
  const [remark, setRemark] = useState('');
  const [error, setError] = useState('');
  useEffect(() => {
    sessionStorage.setItem('UM_GroupId', UM_GroupId);
    sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
    sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
    sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
    sessionStorage.setItem('UM_UserId', UM_UserId);
    sessionStorage.setItem('UM_UserCode', UM_UserCode);

    sessionStorage.setItem('selectedScpId', selectedScpId);

  }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId]);

  const handleOpenModal = (action) => {
    setActionType(action);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setActionType('');
    setError('');
  };


  const handleConfirmAction = () => {
    if (actionType === 'reject' && remark.trim() === '') {
      setError(' *');
      return;
    }
    setIsButtonDisabled(true);
    if (actionType === 'accept') {
      handleStatusUpdate(2);
      toast.success(`Shipment : ${shipmentCode} approved successfully.`, {
        onClose: () => navigate('/dashboard/shipmentapproval'),
      });
    } else if (actionType === 'reject') {
      handleStatusUpdate(3, remark);
      toast.success(`Shipment : ${shipmentCode} rejected successfully.`, {
        onClose: () => navigate('/dashboard/shipmentapproval'),
      });
    }
    handleCloseModal();
  };

  const logAudit = async (module, message, oldValue = "", newValue = "", transactionDetails = []) => {
    const auditLogPayload = {
      AUTR_ScreenName: module,
      AUTR_OldValue: oldValue,
      AUTR_NewValue: newValue,
      AUTR_Message: message,
      AUTR_UserID: UM_UserId,
      AUTR_UserName: UM_UserCode,
      AUTR_AuditType: 16,
      AUTR_SCPID: selectedScpId,
      AUTR_CompanyGrpId: UM_CompanyGrpID,
      AUTR_CompanyID: UM_CompanyID,
      AUTR_CreatedBy: UM_UserId,
      insertAuditTransaction: transactionDetails.length > 0,
      transactionDetails
    };

    try {
      const response = await fetch(`${config.API_URL}/audit/log`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(auditLogPayload),
      });

      if (!response.ok) {
        throw new Error('Failed to log action');
      }
    } catch (error) {
      console.error('Error logging action:', error);
    }
  };

  const logAction = async (action, isError = false) => {
    try {
      const response = await fetch(`${config.API_URL}/api/log`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ module: "Shipment Outward Creation:", action, userCode: UM_UserCode, isError }),
      });
      if (!response.ok) {
        throw new Error('Failed to log action');
      }
    } catch (error) {
      console.error('Error logging action:', error);
    }
  };

  useEffect(() => {
    const fetchShipmentDetails = async () => {
      logAction("fetchShipmentDetails(): Started");
      try {
        // Fetch basic shipment details
        logAction(`fetchShipmentDetails(): Fetching shipment details for shipment code: ${shipmentCode}`);
        const basicDetailsResponse = await fetch(`${config.API_URL}/api/shipment/${shipmentCode}`);
        if (!basicDetailsResponse.ok) {
          throw new Error('Failed to fetch shipment details');
        }
        const basicDetailsData = await basicDetailsResponse.json();
        logAction("fetchShipmentDetails(): Basic shipment details fetched successfully");

        // Fetch table data
        logAction(`fetchShipmentDetails(): Fetching table data for shipment code: ${shipmentCode}`);
        const tableDataResponse = await fetch(`${config.API_URL}/api/tableData/${shipmentCode}`);
        if (!tableDataResponse.ok) {
          throw new Error('Failed to fetch table data');
        }
        const tableData = await tableDataResponse.json();
        logAction("fetchShipmentDetails(): Table data fetched successfully");

        // Combine all fetched data into a single object
        const combinedData = {
          ...basicDetailsData,
          tableData: tableData.tableData,
        };

        console.log('Fetched Shipment Details:', combinedData);
        logAction("fetchShipmentDetails(): Combined data fetched successfully");

        setShipmentDetails(combinedData);
      } catch (error) {
        console.error('Error fetching shipment details:', error);
        logAction(`fetchShipmentDetails(): Error - ${error.message}`, true);
      }
    };
    logAction("useEffect(): Fetching enum type and shipment details");
    fetchShipmentDetails();
  }, [shipmentCode]);


  const calculateBlockQty = () => {
    if (!shipmentDetails || !Array.isArray(shipmentDetails.tableData)) {
      return {};
    }

    const blockQtyMap = {};
    shipmentDetails.tableData.forEach((row) => {
      const { SHPD_ProductCode, shipQty } = row;
      if (blockQtyMap[SHPD_ProductCode]) {
        blockQtyMap[SHPD_ProductCode] += shipQty;
      } else {
        blockQtyMap[SHPD_ProductCode] = shipQty;
      }
    });

    return blockQtyMap;
  };

  const handleStatusUpdate = async (status, remark) => {
    const blockQtyMap = calculateBlockQty();

    try {
      const requests = shipmentDetails.tableData.map(async (row) => {
        const { SHPD_ProductCode: productCode, shipQty, ORDM_OrderNumber: orderNumber } = row;
        const blockQty = blockQtyMap[productCode] || 0;

        const response = await fetch(`${config.API_URL}/shipment/updateStatus`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            status,
            shipmentCode,
            blockQty,
            productId: productCode,
            scpid: selectedScpId,
            shipQty, // Add shipQty for the additional query
            orderNumber, // Add orderNumber for the additional query
            SHPH_Comment: remark,
          }),
        });

        if (!response.ok) {
          throw new Error('Failed to update status');
        }

        return response.json();
      });


      const results = await Promise.all(requests);
      console.log('Status updated:', results);
      logAction(`handleStatusUpdate(): Status updated to ${status} successfully`);
    } catch (error) {
      console.error('Error updating status:', error);
      logAction(`handleStatusUpdate(): Error - ${error.message}`, true);
    }
  };



  // if (loading) {
  //   logAction("Loading: Shipment details are being fetched");
  //   return <div>Loading...</div>;
  // }

  if (!shipmentDetails) {
    
    return;
  }


  const handleRemarkChange = (e) => {
    const value = e.target.value;
    setRemark(value);
    if (error && value.trim() !== '') {
      setError(''); // Clear the error once the user starts typing
    }
  };

  return (
    <>
      <ToastContainer style={{
        marginTop: '73px',
        fontSize: '14px',
        width: '40%',
      }} />
      <div className='main_container'>
        <div className="row">
          <div className="col-md-12">
            <h2 className="formHeading">Shipment Approval</h2>
            <form autoComplete="off">
              <div className="row mb-3">
                <div className="col sm-6">
                  <label className="form-label">Shipment Code</label>
                  <input
                    type="text"
                    className="form-input"
                    value={shipmentDetails.shipmentDetails.SHPH_ShipmentCode || ''}
                    disabled
                  />
                </div>
                <div className="col sm-6">
                  <label className="form-label">Shipment Type</label>
                  <input
                    type="text"
                    className="form-input"
                    value={shipmentDetails.shipmentDetails.SHPH_ShipmentType || ''}
                    disabled
                  />
                </div>

              </div>
              <div className="row mb-3">
                <div className="col-sm-6">
                  <label className="form-label">Logistic Party Name</label>
                  <input
                    type="text"
                    className="form-input"
                    value={shipmentDetails.shipmentDetails.LGCM_Name || ''}
                    disabled
                  />
                </div>
                <div className="col-sm-6">
                  <label className="form-label">Vehicle Number</label>
                  <input
                    type="text"
                    className="form-input"
                    value={shipmentDetails.shipmentDetails.LGCVM_VehicleNumber || ''}
                    disabled
                  />
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-sm-6">
                  <label className="form-label">Scanning Mode</label>
                  <input
                    type="text"
                    className="form-input"
                    value={shipmentDetails.shipmentDetails.SHPH_ByProductVendorScanMode === 1 ? 'Vendor' : 'Product'}
                    disabled
                  />
                </div>
                <div className="col-sm-6">
                  <label className="form-label">Shipment Status</label>
                  <input
                    type="text"
                    className="form-input"
                    value={shipmentDetails.shipmentDetails.StatusDescription || ''}
                    disabled
                  />
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-sm-6">
                  <label className="form-label">Routing for Shipment Location</label>
                  <input
                    type="text"
                    className="form-input"
                    value={shipmentDetails.shipmentDetails.RUTL_Name || ''}
                    disabled
                  />
                </div>
                <div className="col sm-6">
                  <label className="form-label">Shipment Date</label>
                  <input
                    type="text"
                    className="form-input"
                    value={shipmentDetails.shipmentDetails.SHPH_ShipmentDate || ''}
                    disabled
                  />
                </div>
              </div>
            </form>
            <h2 className="formHeading">Order Details</h2>
            <div className="table-responsive">
              <table className="tableClass">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>SCP Name</th>
                    <th>Order Number</th>
                    <th>Product Name</th>
                    <th>Product Code</th>
                    <th>Ordered Quantity</th>
                    <th>Ship Quantity</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(shipmentDetails.tableData) && shipmentDetails.tableData.length > 0 ? (
                    shipmentDetails.tableData.map((row, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{row.SCPM_Name}</td>
                        <td>{row.ORDM_OrderNumber}</td>
                        <td>{row.SHPD_ProductName}</td>
                        <td>{row.SHPD_ProductCode}</td>
                        <td>{row.orderedQty}</td>
                        <td>{row.shipQty}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7">No data available</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>


      {showModal && (
        <div className="popup_overlay">
          <div className="resetpopup">
            <h1>:: User Confirmation ::</h1>
            <h4>
              Are you sure you want to {actionType === "accept" ? "Approve" : "Reject"} Shipment :{" "}
              {shipmentCode} ?
            </h4>

            {actionType === "reject" && (
              <div className="remark_container">
                <span className="me-3 remark_label">
                  Remark : {error && <span style={{ color: "red" }}>{error}</span>}
                </span>
                <textarea
                  type="text"
                  className="remark_text"
                  value={remark}
                  onChange={(e) => handleRemarkChange(e, setRemark, setError)}
                  placeholder="Enter reject remarks"
                  style={{
                    border: "1px solid #ced4da",
                    padding: "10px",
                    fontSize: "16px",
                    resize: "none",
                    overflow: "auto",
                    transition: "height 0.3s",
                    borderRadius: "5px",
                    outline: "none",
                  }}
                />
              </div>
            )}

            <div className="popup_btn_container">
              <button className="yes_btn" onClick={handleConfirmAction}>
                YES
              </button>
              <button className="no_btn" onClick={handleCloseModal}>
                NO
              </button>
            </div>
          </div>
        </div>
      )}

      <div className='button-container'>
        <button onClick={() => handleOpenModal('accept')} className="save_btn" disabled={isButtonDisabled} >APPROVE</button>
        <button onClick={() => handleOpenModal('reject')} className="reset_btn" disabled={isButtonDisabled} >REJECT</button>
        <Link to={`/dashboard/shipmentapproval`} className="list_btn"> BACK </Link>
      </div>
    </>
  );
};

export default ShipmentApproval;

